import ErrorBoundary from '@pages/errorBoundary.page';

import RouteEntry from './routes';

function App() {
  return (
    <ErrorBoundary>
      <RouteEntry />
    </ErrorBoundary>
  );
}

export default App;
